// مبدّل الوضع — زرّان: فاتح · داكن.
//
// وكان بينهما ثالثٌ «حسب الجهاز»، فأُزيل (قرار المالك 22/09/2026: «شيل اللي في النص دي
// ملهاش لازمة»): الاختيارُ عند الناس اختيارُ عينٍ لا إعدادُ نظام، ومربّعٌ ثالثٌ يشرح
// نفسه بأيقونة شاشةٍ زيادةٌ لا تُقرأ.
//
// **واتّباعُ الجهاز باقٍ حيث ينفع**: من لم يختر بعدُ يأخذ وضع جهازه (`auto` في
// theme.ts)، والزرّ الظاهر حينئذٍ هو **النتيجة** لا الاسم المحفوظ — فما يراه المستخدم
// مضيئًا هو ما يراه على الشاشة فعلًا. وأوّل ضغطةٍ تجعل الاختيار له.
import { useTheme, type Theme } from './theme.ts';

const Sun = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
    aria-hidden="true" className="h-[1.1rem] w-[1.1rem]">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 3v2M12 19v2M3 12h2M19 12h2M5.6 5.6l1.4 1.4M17 17l1.4 1.4M18.4 5.6 17 7M7 17l-1.4 1.4" />
  </svg>
);
const Moon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
    strokeLinejoin="round" aria-hidden="true" className="h-[1.1rem] w-[1.1rem]">
    <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z" />
  </svg>
);
const OPTIONS: { key: Exclude<Theme, 'auto'>; ar: string; icon: () => JSX.Element }[] = [
  { key: 'light', ar: 'فاتح', icon: Sun },
  { key: 'dark', ar: 'داكن', icon: Moon },
];

export function ThemeToggle() {
  const { dark, setTheme } = useTheme();
  return (
    <div role="group" aria-label="شكل البرنامج"
      className="inline-flex items-center gap-0.5 rounded-lg border border-slate-300 bg-white p-0.5">
      {OPTIONS.map(o => {
        // المضيء هو الوضع الجاري فعلًا — لا الاسم المحفوظ، فقد يكون «حسب الجهاز»
        const on = dark === (o.key === 'dark');
        const Icon = o.icon;
        return (
          <button key={o.key} type="button" onClick={() => setTheme(o.key)}
            aria-pressed={on} title={o.ar} aria-label={o.ar}
            className={`grid h-8 w-8 place-items-center rounded-md transition-colors ${
              on ? 'bg-brand-600 text-white' : 'text-ink-500 hover:bg-slate-100 hover:text-ink-700'}`}>
            <Icon />
          </button>
        );
      })}
    </div>
  );
}
